(function () {
  'use strict';

  function getRemainingTime(endDateStr) {
    var end   = new Date(endDateStr).getTime();
    var now   = Date.now();
    var delta = Math.max(0, end - now);
    return {
      hours:   Math.floor(delta / 3600000),
      minutes: Math.floor((delta % 3600000) / 60000),
      seconds: Math.floor((delta % 60000) / 1000)
    };
  }

  // Exported for property testing
  if (typeof module !== 'undefined') {
    module.exports = { getRemainingTime: getRemainingTime };
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var section  = el.closest('[data-sale-end]');
    if (!section) return;
    var endDate  = section.dataset.saleEnd;
    var hoursEl  = el.querySelector('[data-hours]');
    var minsEl   = el.querySelector('[data-minutes]');
    var secsEl   = el.querySelector('[data-seconds]');
    if (!hoursEl || !minsEl || !secsEl) return;

    // Validate date
    if (isNaN(new Date(endDate).getTime())) {
      el.hidden = true;
      return;
    }

    function update() {
      var t = getRemainingTime(endDate);
      hoursEl.textContent = pad(t.hours);
      minsEl.textContent  = pad(t.minutes);
      secsEl.textContent  = pad(t.seconds);
      if (t.hours === 0 && t.minutes === 0 && t.seconds === 0) {
        clearInterval(timer);
      }
    }

    update();
    var timer = setInterval(update, 1000);
  });
})();
